export const environmentVariables = {
  NODE_ENV: process.env.NODE_ENV,
};

export const reactEnvironmentVariables = {
  REACT_APP_CI_ENVIRONMENT: process.env.REACT_APP_CI_ENVIRONMENT,
  APPLICATION_ID: process.env.REACT_APP_APPLICATION_ID,
  API_HOST: process.env.REACT_APP_API_HOST,
  KCRM_URL: 'https://puppyspot.kustomerapp.com/app/customers/',
  RAYGUN_KEY: process.env.REACT_APP_RAYGUN_KEY,
};

export const isProduction = () =>
  reactEnvironmentVariables.REACT_APP_CI_ENVIRONMENT === 'production';
